<div class="form-group">
    <nirby-video-select
        [usePreview]="true"
        [video]="video"
        (videoChange)="onVideoChange($event)"
    ></nirby-video-select>
</div>
